import {ModalController} from '../../core/abstracts/controllers/modal-controller';
import selectPositionModalTemplate from '../../../pages/billing/invoices/views/modals/select-positions-modal.tpl.html';

class PosModalController extends ModalController {

    constructor(
        $uibModalInstance,
        $uibModal,
        SweetAlert,
        SelectBox,
        $http,
        $q,
        $filter,
        $scope,
        $rootScope,
        $state,
        Contacts,
        Users,
        $timeout,
        InvoiceTemplates,
        PaymentsService,
        predefinedData,
        rsvpId,
        invoiceIdentifier
    ) {
        super($uibModalInstance);
        this.modal = $uibModal;
        this.sweetAlert = SweetAlert;
        this.selectBox = SelectBox;
        this.api = $http;
        this.queue = $q;
        this.filter = $filter;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.state = $state;
        this.timeout = $timeout;
        this.contactsStore = Contacts.reset({
            listview: 'PosModalContactSelector',
            persist: false
        });
        this.usersStore = Users;
        this.invoiceTemplatesStore = InvoiceTemplates.reset({
            listview: 'PosModalInvoiceTemplates',
            persist: false
        });
        this.paymentsService = PaymentsService;

        this.loading = true;
        this.submitting = false;
        this.deposits = {
            invoice_templates: [],
            payment_types: []
        };
        this.overallSum = 0;
        this.rsvpId = rsvpId;
        this.invoiceIdentifier = invoiceIdentifier;

        this.data = {
            contact_id: -1,
            invoice_template_id: -1,
            invoice_date: new Date(),
            positions: [],
            processing_fee: 0,
            processing_fee_per_person: 0,
            address: '',
            payment_type: 'cash',
            pax_count: 0
        };
        if (predefinedData) {
            this.data = {
                ...this.data,
                ...predefinedData
            }
        }
        this.currentContact = null;

        this.currentSelectedAddressType = 'preferred';
        this.addressEditable = false;
        this.arrangeChangeInProgress = false;

        this.initWatchers();
        this.updateDeposits().then(() => {
            this.initSettings();
        });
    }

    // Internal
    initSettings() {
        if (this.data.contact_id === -1 || !this.data.contact_id) {
            this.data.contact_id = this.usersStore.state.company.settings.billing.pos_default_contact;
        }

        if (this.data.contact_id > -1) {
            this.updateContactData();
        }

        this.data.invoice_template_id = this.usersStore.state.company.settings.billing.pos_default_invoice_template;

        if (this.usersStore.state.company.settings.billing.pos_default_positions.length > 0) {
            const positionsQueue = [];
            _.each(this.usersStore.state.company.settings.billing.pos_default_positions, (posId) => {
                positionsQueue.push(this.api.get(`billing/positions/${posId}`));
            });

            this.queue.all(positionsQueue)
                .then((positionResults) => {
                    _.each(positionResults, (result) => {
                        const curPos = result.data.data;

                        this.data.positions.push({
                            order: this.data.positions.length + 1,
                            position_id: curPos.id,
                            label: curPos.label,
                            originalLabel: _.cloneDeep(curPos.label),
                            description: curPos.description,
                            tax_rate: curPos.tax_rate,
                            child_positions: curPos.child_positions,
                            price_per_unit_steps: curPos.price_per_unit_steps,
                            price_per_unit: curPos.price_per_unit,
                            default_price_per_unit: curPos.price_per_unit,
                            unit: curPos.unit,
                            amount: 0
                        });
                    });
                });
        }
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.currentSelectedAddressType;
        }, (value) => {
            this.updateAddress();
        });
        this.scope.$watch(() => {
            return this.data.positions;
        }, (newValue, oldValue) => {
            if (!this.arrangeChangeInProgress) {
                this.checkPositionAmountSum(newValue, oldValue);
            }
            this.calculateOverallSum();
        }, true);
        this.scope.$watch(() => {
            return this.data.processing_fee;
        }, (value) => {
            this.calculateOverallSum();
        }, true);
        this.scope.$watch(() => {
            return this.data.processing_fee_per_person;
        }, (value) => {
            this.calculateOverallSum();
        }, true);
        this.scope.$watch(() => {
            return this.data.invoice_template_id;
        }, (value) => {
            this.handleInvoiceTemplateChanged()
        }, true);
    }

    handleInvoiceTemplateChanged() {
        this.deposits.invoice_templates.forEach((row) => {
            if(row.id === this.data.invoice_template_id) {
                this.data.processing_fee_per_person = row.processing_costs_per_person
            }
        })
    }

    calculateOverallSum() {
        let overallSum = this.data.processing_fee
            + (this.data.pax_count * this.data.processing_fee_per_person);

        _.each(this.data.positions, (v) => {
            overallSum += v.amount * v.price_per_unit;
            overallSum += v.child_positions.reduce((out, childPos) => {
                return out + (childPos.bundle_amount * v.amount) * childPos.price_per_unit
            }, 0);
        });

        this.overallSum = overallSum;
    }

    // View functions
    changeContact() {
        this.selectBox.single(this.contactsStore, {
            displayField: 'cnr_full_name_co'
        }).then((result) => {
            this.data.contact_id = result.data;
            this.updateContactData();
        });
    }

    addPosition() {
        this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: selectPositionModalTemplate,
            size: 'md',
            controller: 'BillingSelectPositionController',
            controllerAs: 'vm'
        }).result.then((data) => {
            this.data.positions.push({
                order: this.data.positions.length + 1,
                position_id: data.id,
                label: data.label,
                description: data.description,
                tax_rate: data.tax_rate,
                price_per_unit: data.price_per_unit,
                child_positions: data.child_positions,
                default_price_per_unit: data.price_per_unit,
                unit: data.unit,
                price_per_unit_steps: data.price_per_unit_steps,
                amount: 1
            });
        }, () => {

        });
    }

    removePosition(position) {
        const index = this.data.positions.indexOf(position);

        if (index > -1) {
            this.arrangeChangeInProgress = true
            this.data.positions.splice(index, 1);
            this.reArrangePositionsOrder()
        }
    }

    moveUp(position) {
        this.arrangeChangeInProgress = true
        if (position.order > 1) {
            let oldOrder = position.order;
            _.each(this.getPositionsOrdered(), (curPos) => {
                if (curPos.order === oldOrder - 1) {
                    curPos.order++;
                }
            });
            position.order--;
        }

        this.reArrangePositionsOrder()
    }

    moveDown(position) {
        this.arrangeChangeInProgress = true
        if (position.order < this.getPositionsOrdered().length) {
            let oldOrder = position.order;
            _.each(this.getPositionsOrdered(), (curPos) => {
                if (curPos.order === oldOrder + 1) {
                    curPos.order--;
                }
            });
            position.order++;
        }

        this.reArrangePositionsOrder()
    }

    reArrangePositionsOrder() {
        this.arrangeChangeInProgress = true

        let currentOrder = 1;
        _.each(this.getPositionsOrdered(), (curPos) => {
            curPos.order = currentOrder++;
        });

        this.scope.$applyAsync();
        this.timeout(() => {
            this.arrangeChangeInProgress = false
        }, 0, false);
    }

    getPositionsOrdered() {
        return this.filter('orderBy')(this.data.positions, 'order');
    }

    // Internal
    updateDeposits() {
        const queue = [];

        this.invoiceTemplatesStore.commit('setPermanentFilters', {'enable_for_invoice': true});
        this.invoiceTemplatesStore.commit('setSort', {'title': 'asc'});
        this.invoiceTemplatesStore.commit('setColumns', [{
            key: 'title',
            label: 'Title',
            main: true,
            visible: true
        }, {
            key: 'enable_for_invoice',
            label: 'Enable for Invoice',
            type: 'boolean',
            main: false,
            visible: false
        }, {
            key: 'number_circle.id',
            label: 'Number circle ID',
            type: 'integer',
            main: false,
            visible: true
        }, {
            key: 'number_circle.id',
            label: 'Number circle ID',
            type: 'integer',
            main: false,
            visible: true
        }, {
            key: 'tax_rate',
            label: 'Tax rate',
            type: 'float',
            main: false,
            visible: true
        }, {
            key: 'processing_costs_per_person',
            label: 'Processing Costs per person',
            type: 'float',
            main: false,
            visible: true
        }]);

        queue.push(this.invoiceTemplatesStore.dispatch('getData').then(() => {
            this.deposits.invoice_templates = this.invoiceTemplatesStore.state.data;
            this.handleInvoiceTemplateChanged();
        }));

        queue.push(this.paymentsService.getPosTypes().then((types) => {
            this.deposits.payment_types = types;
        }));

        return this.queue.all(queue);
    }

    updateContactData() {
        this.api.get(`contacts/${this.data.contact_id}?include=categories`).then((response) => {
            this.currentContact = response.data.data;
            this.updateAddress();
        }, () => {
            this.data.contact_id = -1;
            this.currentContact = null;
        });
    }

    updateAddress() {
        this.addressEditable = (this.currentSelectedAddressType === 'custom');

        if (!this.currentContact) {
            return;
        }

        if (this.currentSelectedAddressType !== 'custom') {
            let addressPrefix;
            switch (this.currentSelectedAddressType) {
                case 'preferred':
                    addressPrefix = 'preferred_';
                    break;
                case 'private':
                    addressPrefix = '';
                    break;
                case 'business':
                    addressPrefix = 'business_';
                    break;
            }

            let address = '';
            if (this.currentSelectedAddressType === 'business' || (this.currentSelectedAddressType === 'preferred' && this.currentContact.business_preferred)) {
                address += (this.currentContact.company_name).trim();
                if (address !== '') {
                    address += "\n";
                }
                const nameString = (this.currentContact.title + ' ' + this.currentContact.first_name + ' ' + this.currentContact.last_name).trim();
                if (nameString) {
                    address += 'z. H. ' + nameString + "\n";
                } else {
                    address += "\n";
                }
            } else if (this.currentSelectedAddressType === 'shipping' && this.currentContact.shipping_company_name !== '') {
                address += (this.currentContact.shipping_company_name).trim();
                const nameString = (this.currentContact.title + ' ' + this.currentContact.first_name + ' ' + this.currentContact.last_name).trim();
                if (nameString) {
                    address += 'z. H. ' + nameString + "\n";
                } else {
                    address += "\n";
                }
            } else {
                address += (this.currentContact.title + ' ' + this.currentContact.first_name + ' ' + this.currentContact.last_name).trim() + "\n";
            }

            address += this.currentContact[addressPrefix + 'street'] + ' ' + this.currentContact[addressPrefix + 'house_number'] + "\n";
            if (this.currentContact[addressPrefix + 'street_2']) {
                address += this.currentContact[addressPrefix + 'street_2'] + "\n";
            }
            address += this.currentContact[addressPrefix + 'zip'] + ' ' + this.currentContact[addressPrefix + 'city'] + "\n";

            let countryName = '',
                currentCountryCode = this.currentContact[addressPrefix + 'country'];
            if (currentCountryCode) {
                currentCountryCode = currentCountryCode.toUpperCase();
            }
            if (currentCountryCode !== 'DE') {
                _.forEach(this.rootScope.deposit.countries, function (country) {
                    if (country.code === currentCountryCode) {
                        countryName = country.name;
                    }
                });
            }
            address += (countryName + "\n").trim();

            this.data.address = address.trim();
        }
    }

    submit(form) {
        this.submitting = true;

        if (!form.$valid) {
            this.submitting = false;
            this.sweetAlert.error('Validation', 'Please check your data');
            return;
        }

        if (this.data.contact_id < 0) {
            this.submitting = false;
            this.sweetAlert.error('No Contact', 'You need to select a contact, to do a Cash Sale');
            return;
        }

        if (this.data.positions.length < 1) {
            this.submitting = false;
            this.sweetAlert.error('No positions', 'Please make sure to have at minimum 1 position');
            return;
        }

        _.each(this.data.positions, (v, k) => {
            if (!this.data.positions[k].billable_type) {
                if (this.rsvpId) {
                    this.data.positions[k].billable_type = 'rsvp';
                    this.data.positions[k].billable_id = this.rsvpId;
                } else {
                    this.data.positions[k].billable_type = 'contact';
                    this.data.positions[k].billable_id = this.data.contact_id;
                }
            }
        });

        const dataForApi = {
            invoice_template_id: this.data.invoice_template_id,
            extended: {
                address: this.data.address,
                invoice_date: this.data.invoice_date,
                processing_costs_general: this.data.processing_fee,
                processing_costs_per_person: this.data.processing_fee_per_person,
                shipping: false
            },
            positions: _.cloneDeep(this.data.positions)
                .filter((pos) => {
                    return pos.amount > 0
                })
        };

        if (this.rsvpId) {
            const dataForRsvpInvoice = {
                ...dataForApi,
                extended: {},
                positions: {}
            }

            dataForRsvpInvoice.extended[this.invoiceIdentifier] = dataForApi.extended;
            dataForRsvpInvoice.positions[this.invoiceIdentifier] = dataForApi.positions;
            this.api.post(
                `billing/invoices/rsvp/${this.rsvpId}/invoice`,
                dataForRsvpInvoice
            ).then((invoiceResponse) => {
                this.furtherProcessInvoice(invoiceResponse.data.data[0]);
            }, () => {
                this.sweetAlert.error('Error on saving', 'There was an error while creating the invoice. Please try again.')
                this.submitting = false;
            });
        } else {
            this.api.post(`billing/invoices/contact/${this.data.contact_id}/invoice/one`, dataForApi).then((invoiceResponse) => {
                this.furtherProcessInvoice(invoiceResponse.data.data);
            }, () => {
                this.sweetAlert.error('Error on saving', 'There was an error while creating the invoice. Please try again.')
                this.submitting = false;
            });
        }
    }

    furtherProcessInvoice(invoice) {
        this.api.post(`billing/invoices/${invoice.id}/payments`, {
            amount: invoice.sum_after_tax,
            type: this.data.payment_type,
            payment_time: new Date(),
            status: 'success'
        }).then((paymentResponse) => {
            if (this.usersStore.state.company.settings.billing.pos_directly_prepare_pickup) {
                this.api.post(`vouchers/generate/invoice/${invoice.id}`).then(() => {
                    this.api.post(`billing/invoices/print-pickup`, {
                        invoices: [invoice.id]
                    }).then(() => {
                        this.sweetAlert.success('Cash sale succesful', 'Cash sale was successful and all documents will now start to print');
                        this.goToInvoiceDetails(invoice.id);
                    }, () => {
                        this.sweetAlert.error('Error while printing documents', 'Please start pickup manually');
                        this.goToInvoiceDetails(invoice.id);
                    });
                }, () => {
                    this.sweetAlert.error('Error while creating vouchers', 'Pleae have a look if the vouchers are correct');
                    this.goToInvoiceDetails(invoice.id);
                })
            } else {
                this.sweetAlert.success('Invoice create', 'The invoice has been created successfully');
                this.goToInvoiceDetails(invoice.id);
            }
        }, () => {
            this.sweetAlert.error('Payment not created', `Invoice with number ${invoiceResponse.data.data.number} was created, there just have been problems in creating the payment. Please manually check.`);
            this.state.go('app.billing.invoices.details', {id: invoiceResponse.data.data.id});
            this.close();
            this.submitting = false;
        });
    }

    checkPositionAmountSum(newVal, oldVal) {
        if (newVal.length !== oldVal.length) {
            return;
        }

        for (let i = 0; i < newVal.length; i++) {
            const newPos = newVal[i],
                oldPos = oldVal[i];

            if (oldPos.amount === newPos.amount) {
                continue;
            }

            const oldPrice = this.getPositionPriceForAmount(newPos, oldPos.amount),
                newPrice = this.getPositionPriceForAmount(newPos, newPos.amount);

            if(newPos.price_per_unit === oldPrice && oldPrice !== newPrice) {
                this.data.positions[i].price_per_unit = newPrice
            }
        }
    }

    getPositionPriceForAmount(position, amount) {
        if(!position.price_per_unit_steps || Object.keys(position.price_per_unit_steps).length === 0) {
            return position.price_per_unit
        }

        let price = position.default_price_per_unit

        const pricePerUnitKeys = Object.keys(position.price_per_unit_steps)
            .sort((a,b) => parseFloat(a)-parseFloat(b));

        for(let i = 0; i<pricePerUnitKeys.length; i++) {
            const currentKey = pricePerUnitKeys[i]

            if(amount >= parseFloat(currentKey)) {
                price = position.price_per_unit_steps[currentKey]
            }
        }

        return price
    }

    goToInvoiceDetails(invoiceId) {
        this.state.go('app.billing.invoices.details', {id: invoiceId});
        this.close();
    }
}

PosModalController.$inject = [
    '$uibModalInstance',
    '$uibModal',
    'SweetAlert',
    'SelectBox',
    '$http',
    '$q',
    '$filter',
    '$scope',
    '$rootScope',
    '$state',
    'Contacts',
    'Users',
    '$timeout',
    'InvoiceTemplates',
    'PaymentsService',
    'predefinedData',
    'rsvpId',
    'invoiceIdentifier'
];

/**
 * @ngdoc controller
 * @name modules.pos:PosModalController
 * @restrict EA
 * @element
 *
 * @description
 *
 */
angular
    .module('festzelt-os.modules.pos')
    .controller('PosModalController', PosModalController);



// WEBPACK FOOTER //
// ./src/app/modules/pos/controllers/pos-modal-controller.js